// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2abb449f","158":"600d6f81","182":"51d14e11","290":"5c1cc286","513":"b7d90d14","534":"606fe764","587":"d4160b12","782":"4e0c341e","786":"6f8d7926","850":"afa2b36c"}[chunkId] + ".chunk.js";
};